import React from 'react';
import PropTypes from 'prop-types';

const ExpandCollapseAll = React.memo(({
  allExpanded,
  expandAll,
  collapseAll,
  className,
}) => {
  const buttonText = allExpanded ? 'Collapse all' : 'Expand all';
  const buttonAction = allExpanded ? collapseAll : expandAll;
  return (
    <div className={className}>
      <button
        type="button"
        onClick={buttonAction}
      >
        {buttonText}
      </button>
    </div>
  );
});

ExpandCollapseAll.propTypes = {
  allExpanded: PropTypes.bool,
  expandAll: PropTypes.func,
  collapseAll: PropTypes.func,
  className: PropTypes.string,
};

export { ExpandCollapseAll };
